function initMainSwiperBoxes(root = document) {
  root.querySelectorAll('.main-swiper-wraper-box').forEach((wrapper) => {
    if (wrapper.classList.contains('predictive-search-products-slider')) return;
    if (wrapper.dataset.swiperInitialized === 'true') {
      return;
    }

    const sliderEl = wrapper.querySelector('.carousel-slider-product');
    const progressBar = wrapper.querySelector('.progress-bar-customer');

    if (!sliderEl) {
      return;
    }

    // Count the number of slides
    const slides = sliderEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const enableMousewheel = slideCount >= 4;

    const productSwiper = new Swiper(sliderEl, {
      slidesPerView: 3,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: wrapper.querySelector('.next-button'),
        prevEl: wrapper.querySelector('.prev-button'),
      },
      mousewheel: {
        enabled: enableMousewheel,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 0 },
        580: { slidesPerView: 2.5 },
        350: { slidesPerView: 2.5 },
      },
      on: {
        init: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
        slideChange: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
        resize: function () {
          if (progressBar) updateProgress(this, progressBar);
        },
      },
    });

    if (progressBar) {
      progressBar.addEventListener('input', function () {
        const totalSlides = productSwiper.slides.length;
        const slidesPerView = productSwiper.params.slidesPerView;
        let steps = totalSlides - slidesPerView + 1;
        if (steps < 1) steps = 1;

        const targetStep = Math.round((this.value / 100) * (steps - 1));
        productSwiper.slideTo(targetStep);
      });
    }

    wrapper.querySelectorAll('svg').forEach((svg) => {
      svg.querySelectorAll('*').forEach((el) => {
        if (el.hasAttribute('stroke')) {
          el.setAttribute('stroke', '#002F6C');
        }
      });
    });

    wrapper.dataset.swiperInitialized = 'true';
  });

  function updateProgress(swiperInstance, progressEl) {
    if (!progressEl) return;
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    let steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    const currentStep = swiperInstance.activeIndex;
    const progress = (currentStep / (steps - 1)) * 100;
    progressEl.value = progress;
  }
}

window.initMainSwiperBoxes = initMainSwiperBoxes;

function runWhenVisible(target, callback, options = {}) {
  if (!target || target.dataset.deferInitBound === 'true') return;
  target.dataset.deferInitBound = 'true';

  const rootMargin = options.rootMargin || '250px 0px';

  const run = () => {
    if (target.dataset.deferInitDone === 'true') return;
    target.dataset.deferInitDone = 'true';
    callback();
  };

  if (typeof IntersectionObserver === 'undefined') {
    run();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        run();
      }
    });
  }, { rootMargin });

  observer.observe(target);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.main-swiper-wraper-box').forEach((wrapper) => {
    runWhenVisible(wrapper, function () {
      initMainSwiperBoxes(wrapper.parentElement || document);
    });
  });

  const progressBarCard = document.querySelector('.progress-bar-card');
  let cardSwiper = null;

  function initThreeCardSwiper() {
    if (cardSwiper || !document.querySelector('.flex-row-three')) return;

    cardSwiper = new Swiper('.flex-row-three', {
      slidesPerView: 3,
      spaceBetween: 29,
      speed: 400,
      navigation: {
        nextEl: '.card-swiper-next',
        prevEl: '.card-swiper-prev',
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      breakpoints: {
        0: { slidesPerView: 1.19, spaceBetween: 20 },
        650: { slidesPerView: 2, spaceBetween: 15 },
        992: { slidesPerView: 2.5, spaceBetween: 15 },
        1200: { slidesPerView: 3, spaceBetween: 29 },
      },
      on: {
        init: function () { updateProgress(this); },
        slideChange: function () { updateProgress(this); },
        resize: function () { updateProgress(this); }
      }
    });
  }

  if (document.querySelector('.flex-row-three')) {
    initThreeCardSwiper();
  }

  function updateProgress(swiperInstance) {
    if (!progressBarCard) return;
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    let steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    const currentStep = swiperInstance.activeIndex;
    const progress = (currentStep / (steps - 1)) * 100;
    progressBarCard.value = progress;
  }

  if (progressBarCard) {
    progressBarCard.addEventListener('input', function () {
      if (!cardSwiper) return;
      const totalSlides = cardSwiper.slides.length;
      const slidesPerView = cardSwiper.params.slidesPerView;
      let steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      const targetStep = Math.round((this.value / 100) * (steps - 1));
      cardSwiper.slideTo(targetStep);
    });
  }
});


/* home-page-collection-slider  */
function initHomePageCollectionSlider(root = document) {
  root.querySelectorAll('.home-page-collection-section').forEach((section) => {
    const progressBar = section.querySelector('.progress-bar-collection');
    const swiperEntries = [];

    function getStepCount(swiperInstance) {
      const totalSlides = swiperInstance.slides.length;
      const slidesPerView = Number(swiperInstance.params.slidesPerView) || 1;
      return Math.max(totalSlides - slidesPerView + 1, 1);
    }

    function updateProgress(swiperInstance) {
      if (!progressBar || !swiperInstance) return;
      const steps = getStepCount(swiperInstance);
      const currentStep = Math.min(swiperInstance.activeIndex, steps - 1);
      progressBar.value = steps === 1 ? 0 : (currentStep / (steps - 1)) * 100;
    }

    function getActiveSwiperEntry() {
      return (
        swiperEntries.find((entry) => window.getComputedStyle(entry.block).display !== 'none') ||
        swiperEntries[0]
      );
    }

    section.querySelectorAll('.block-inner-content').forEach((block) => {
      const sliderEl = block.querySelector('.home-page-collection-swiper');
      if (!sliderEl || sliderEl.dataset.swiperInitialized === 'true') return;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 2.35,
        spaceBetween: 40,
        loop: false,
        navigation: {
          nextEl: block.querySelector('.swiper-next-col'),
          prevEl: block.querySelector('.swiper-prev-col'),
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: false,
        },
        breakpoints: {
          320: { slidesPerView: 1.75, spaceBetween: 10 },
          540: { slidesPerView: 2.5, spaceBetween: 20 },
          768: { slidesPerView: 2.5, spaceBetween: 20 },
          950: { slidesPerView: 3.15, spaceBetween: 20 },
          1024: { slidesPerView: 3.2, spaceBetween: 20 },
          1025: { slidesPerView: 1.6, spaceBetween: 30 },
          1200: { slidesPerView: 2.35, spaceBetween: 20 },
        },
        on: {
          init: function () {
            if (getActiveSwiperEntry()?.swiper === this) updateProgress(this);
          },
          slideChange: function () {
            if (getActiveSwiperEntry()?.swiper === this) updateProgress(this);
          },
          resize: function () {
            if (getActiveSwiperEntry()?.swiper === this) updateProgress(this);
          },
        },
      });

      const nextButton = block.querySelector('.next-slide-item');
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          swiper.slideNext();
        });
      }

      swiperEntries.push({ block, swiper });
      sliderEl.dataset.swiperInitialized = 'true';
    });

    if (progressBar && swiperEntries.length > 0) {
      if (progressBar.dataset.swiperBound !== 'true') {
        progressBar.addEventListener('input', function () {
          const activeEntry = getActiveSwiperEntry();
          if (!activeEntry) return;
          const steps = getStepCount(activeEntry.swiper);
          const targetStep = Math.round((Number(this.value) / 100) * (steps - 1));
          activeEntry.swiper.slideTo(targetStep);
        });
        progressBar.dataset.swiperBound = 'true';
      }

      const syncProgressForActiveTab = () => {
        updateProgress(getActiveSwiperEntry()?.swiper);
      };

      section.querySelectorAll('.gender_tab').forEach((tabButton) => {
        tabButton.addEventListener('click', function () {
          requestAnimationFrame(syncProgressForActiveTab);
        });
      });

      syncProgressForActiveTab();
      window.addEventListener('resize', syncProgressForActiveTab);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.home-page-collection-section').forEach((section) => {
    runWhenVisible(section, function () {
      initHomePageCollectionSlider(section.parentElement || document);
    });
  });
});


/* customer review */

document.addEventListener('DOMContentLoaded', function () {
  const progressBarCustomer = document.querySelector('.progress-bar-customer');
  let customerSwiper = null;

  function initCustomerSwiper() {
    if (customerSwiper || !document.querySelector('.customerSwiper')) return;

    customerSwiper = new Swiper('.customerSwiper', {
      slidesPerView: 3.10,
      spaceBetween: 30,
      speed: 400,
      navigation: {
        nextEl: '.customer-swiper-next',
        prevEl: '.customer-swiper-prev',
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      breakpoints: {
        0: { slidesPerView: 1.5, spaceBetween: 20 },
        576: { slidesPerView: 2.5, spaceBetween: 15 },
        992: { slidesPerView: 3, spaceBetween: 15 },
        1200: { slidesPerView: 3.10, spaceBetween: 20 },
        1350: { slidesPerView: 3.10, spaceBetween: 30 },
      },
      on: {
        init: function () { updateProgress(this); },
        slideChange: function () { updateProgress(this); },
        resize: function () { updateProgress(this); }
      }
    });
  }

  const customerRegion = document.querySelector('.customerSwiper');
  if (customerRegion) {
    runWhenVisible(customerRegion, initCustomerSwiper);
  }

  function updateProgress(swiperInstance) {
    if (!progressBarCustomer) return;
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    let steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    const currentStep = swiperInstance.activeIndex;
    const progress = (currentStep / (steps - 1)) * 100;

    progressBarCustomer.value = progress;
  }

  if (progressBarCustomer) {
    progressBarCustomer.addEventListener('input', function () {
      if (!customerSwiper) return;
      const totalSlides = customerSwiper.slides.length;
      const slidesPerView = customerSwiper.params.slidesPerView;
      let steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      const targetStep = Math.round((this.value / 100) * (steps - 1));
      customerSwiper.slideTo(targetStep);
    });
  }
});



/* information grid-globle */

document.addEventListener('DOMContentLoaded', function () 
{
  const progressBar = document.querySelector('.progress-bar1');
  let swiper = null;

  function initInformationSwiper() {
    if (swiper || !document.querySelector('.information-grid-swiper')) return;

    swiper = new Swiper('.information-grid-swiper', {
      slidesPerView: 4,
      spaceBetween: 20,
      speed: 400,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: false,
      },
      breakpoints: {
        0: { slidesPerView: 1.15, spaceBetween:20 },
        576: { slidesPerView: 2.5, spaceBetween: 15 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 20 },
      },
      on: {
        init: function () { updateProgress(this); },
        slideChange: function () { updateProgress(this); },
        resize: function () { updateProgress(this); }
      }
    });
  }

  const infoRegion = document.querySelector('.information-grid-swiper');
  if (infoRegion) {
    runWhenVisible(infoRegion, initInformationSwiper);
  }
  function updateProgress(swiperInstance) {
    if (!progressBar) return;
    const totalSlides = swiperInstance.slides.length;
    const slidesPerView = swiperInstance.params.slidesPerView;
    let steps = totalSlides - slidesPerView + 1;
    if (steps < 1) steps = 1;

    const currentStep = swiperInstance.activeIndex;
    const progress = (currentStep / (steps - 1)) * 100;

    progressBar.value = progress;
  }
  if (progressBar) {
    progressBar.addEventListener('input', function () {
      if (!swiper) return;
      const totalSlides = swiper.slides.length;
      const slidesPerView = swiper.params.slidesPerView;
      let steps = totalSlides - slidesPerView + 1;
      if (steps < 1) steps = 1;

      const targetStep = Math.round((this.value / 100) * (steps - 1));
      swiper.slideTo(targetStep);
    });
  }
});
    